/**
 * Procedure Categories and Procedures for Diploma in Physical Medicine & Rehabilitation (DPMR) students
 * Extracted with strict evidence from official NMC PDF
 */
export const PMR_PROCEDURES = {
  "Therapeutic Injections & Interventional Physiatry": [
    "Intra-Articular and Peri-Articular Injections",
    "Trigger-Point Injections",
    "Epidural Injections",
    "Botulinum Toxin Injections",
    "Phenol & Alcohol Nerve Blocks",
  ],
  "Bedside & Conservative Procedures": [
    "Debridement of Wounds",
    "Plaster Cast Application",
    "Traction Application",
    "Catheterization",
    "Intubation",
  ],
  "Rehabilitative Surgical Operations (Performed under supervision)": [
    "Deformity Correction Surgeries (for Polio, Cerebral Palsy, and Clubfoot)",
    "Tendon Transfer Surgeries",
    "Revision of Amputation Stump",
    "Surgical Closure of Pressure Sores",
  ],
};

export const PMR_CATEGORIES = Object.keys(PMR_PROCEDURES);

export const isDiplomaInPMRDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("dpmr") ||
    d.includes("pmr") ||
    d.includes("physical medicine") ||
    d.includes("rehabilitation")
  );
};
